var _path, _path2, _path3, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownloadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Download"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Fill 1",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.83398 8.51025C5.59248 8.51025 5.39648 8.31425 5.39648 8.07275V1.04883C5.39648 0.807328 5.59248 0.611328 5.83398 0.611328C6.07548 0.611328 6.27148 0.807328 6.27148 1.04883V8.07275C6.27148 8.31425 6.07548 8.51025 5.83398 8.51025Z",
    fill: "#575BE8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Fill 3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.83394 8.51059C5.71785 8.51059 5.60585 8.46451 5.52419 8.38167L3.82319 6.67426C3.65285 6.50276 3.65344 6.22567 3.82435 6.05534C3.99585 5.88501 4.27235 5.88501 4.44269 6.05651L5.83394 7.45359L7.22519 6.05651C7.39552 5.88501 7.67202 5.88501 7.84352 6.05534C8.01444 6.22567 8.01502 6.50276 7.84469 6.67426L6.14369 8.38167C6.06202 8.46451 5.95002 8.51059 5.83394 8.51059Z",
    fill: "#575BE8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 7"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8732_59028",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 3,
    width: 12,
    height: 9
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Clip 6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 3.37109H11.6665V11.3884H0V3.37109Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8732_59028)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill 5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.08542 11.3884H2.58708C1.16083 11.3884 0 10.2282 0 8.80134V5.95176C0 4.52843 1.15792 3.37109 2.58183 3.37109H3.13075C3.37225 3.37109 3.56825 3.56709 3.56825 3.80859C3.56825 4.05009 3.37225 4.24609 3.13075 4.24609H2.58183C1.64033 4.24609 0.875 5.01084 0.875 5.95176V8.80134C0.875 9.74576 1.64267 10.5134 2.58708 10.5134H9.08542C10.0258 10.5134 10.7917 9.74751 10.7917 8.80718V5.95818C10.7917 5.01376 10.0234 4.24609 9.08017 4.24609H8.5365C8.295 4.24609 8.099 4.05009 8.099 3.80859C8.099 3.56709 8.295 3.37109 8.5365 3.37109H9.08017C10.5064 3.37109 11.6667 4.53193 11.6667 5.95818V8.80718C11.6667 10.2305 10.5082 11.3884 9.08542 11.3884Z",
    fill: "#575BE8"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/download-icon.cf75ef464621cf4b37f6d2b2ac8595ae.svg";
export { ForwardRef as ReactComponent };